// Content for Nitin Gupta — Double Your Exports (frontend-only mocks)

export const brand = {
  name: "Nitin Gupta",
  firm: "The Next Design",
  role: "Export Marketing Strategist | Author",
  phone: "+91 98183 72742",
  phoneRaw: "919818372742",
};

export const navLinks = [
  { label: "About", href: "/#about" },
  { label: "Solutions", href: "/#solutions" },
  { label: "VPV", href: "/vpv", route: true },
  { label: "Brand", href: "/brand", route: true },
  { label: "The Book", href: "/#book" },
  { label: "Clients", href: "/#clients" },
  { label: "Contact", href: "/#contact" },
];

export const hero = {
  eyebrow: "The Uncomfortable Truth",
  headline: "Most manufacturers pour lakhs to crores into exhibitions every year,",
  headlineAccent: "and come home empty.",
  tagline: ["Stand out.", "Sell more.", "Become a global brand."],
  sub: "I help serious manufacturers do exactly that. Not just win one more order, but grow into a name buyers seek out.",
  desc: "You poured your sweat, your savings and years of your life into building a world-class factory. My job is simple. Make sure the world finally sees it, and you get the respect and growth you deserve.",
  photo: "/assets/nitin.png",
};

export const stats = [
  { value: "26+", label: "Years of experience" },
  { value: "2x", label: "The export goal" },
  { value: "80%", label: "Lead conversion" },
  { value: "100s", label: "Manufacturers guided" },
];

export const industries = [
  "Auto", "Dairy", "Engineering", "Candy", "Spices",
  "Snacks", "Rubber", "Fasteners", "Machine Manufacturing", "Transformers",
];

export const problem = {
  eyebrow: "Why It Happens",
  title: "So where does all that money quietly disappear?",
  intro:
    "The custom stall. The glossy brochures. The flights, the hotels, the late nights on your feet. Then the show ends and the silence begins. Lead after lead goes cold, and you are left quietly wondering where it all slipped away.",
  points: [
    {
      title: "The right buyers never reach you",
      body: "A crowded aisle is not a serious buyer. Footfall flatters your ego. It rarely fills your order book.",
    },
    {
      title: "Your ROI quietly disappears",
      body: "You fly home with a fat stack of visiting cards, and almost none of them ever become money in the bank.",
    },
    {
      title: "You blend into the crowd",
      body: "To a buyer walking past, you look like every other stall. Nothing says why you, so they simply move on.",
    },
    {
      title: "Rivals just look more trustworthy",
      body: "Buyers do not always pick the best factory. They pick the one they believe in first, and belief is built, not hoped for.",
    },
  ],
  closer:
    "Showing up is no longer enough. Buyers have endless choices, and trust is the only currency that closes deals. Work with me and you will not just display products. You will create an experience that earns belief, holds attention, and quietly turns visitors into buyers.",
};

export const solutions = [
  {
    title: "Magnetic Exhibition Booth Design",
    body: "A stall people cannot walk past. Designed to stop feet, start conversations, and make buyers remember you long after the show.",
    image: "/assets/stall.png",
    tag: "01",
  },
  {
    title: "Strategic Marketing Collaterals",
    body: "Materials that make a buyer sit up and think, these people are serious. Credibility they can hold in their hands.",
    image: "/assets/collateral.png",
    tag: "02",
  },
  {
    title: "Virtual Plant Visit (VPV)",
    body: "Walk buyers through your entire factory in a single click, building real trust in the very first meeting. See how it works.",
    image: "/assets/vpv.jpg",
    tag: "03",
    link: "/vpv",
  },
  {
    title: "Total Lead Control (TLC) Journal",
    body: "Never let a hot lead go cold again. A simple system to track, follow up, and turn conversations into long term business.",
    image: "/assets/tlc.png",
    tag: "04",
  },
];

export const book = {
  eyebrow: "The Only Book Of Its Kind",
  title: "Export Business Booster Guide",
  desc: "I wrote this for the manufacturer who knows they are capable of far more than their order book shows. It may be the only book on the market with a laser focus on doubling your exports.",
  points: [
    "5 reasons good manufacturers keep losing leads at international trade shows",
    "The one silent mistake that could be costing you crores",
    "The real reason your margins stay painfully thin",
    "7 strategies to lift your brand and win the export orders you deserve",
  ],
  cover: "/assets/book.png",
  quote: {
    text: "What an insightful and actionable book it was. I started reading it this Sunday with my tea and finished it before lunch, highlighting page after page with actions to take. I will recommend it to every business owner friend I have.",
    author: "Dr. Raghunandan Jagdish, PhD",
    title: "CEO, Nandan GSE",
    avatar: "/assets/raghunandan.jpg",
  },
};

export const about = {
  eyebrow: "Meet The Man Behind The Innovation",
  name: "Nitin Gupta",
  role: "Founder, The Next Design. Export Marketing Strategist and Author.",
  photo: "/assets/nitin.png",
  story: [
    "Here is why I do what I do. Two years ago I went through spine surgery. Lying on that recovery bed I realised something I had been too busy to admit. We should never take a single day for granted. That is when I decided to point my knack for solving problems at the people I respect most, manufacturers.",
    "After hundreds of honest conversations, I found a gap that is quietly hurting them. The hardest part is, most do not even know it is there. They pour their sweat and blood into building world-class factories, yet they never get to show the world what they are truly capable of.",
    "That is the mission I am on. To help them show their real strength to the world and double their business in the shortest time possible. Not with hype. With trust.",
  ],
  credentials: [
    "26 years across exhibition design, Virtual Plant Visits and high impact marketing collaterals",
    "Trusted by industry leaders like NTPC, AAI and Kohler India",
    "A go to partner for ambitious MSMEs in food, engineering and auto",
    "Author of the Export Business Booster Guide",
  ],
};

export const testimonial = {
  eyebrow: "Here is Why You Need This Call",
  text:
    "I am a Profit and Market Share Multiplier Expert for mid-size and large organizations. I have over 40 years of industry experience, 18 of them heading well known companies. I can vouch for the fact that Nitin can see what others cannot. In a single one hour discussion, he handed me a golden nugget that can do wonders for my business. He has genuine out of the box thinking and would be a great contributor for any growth oriented business owner.",
  author: "Vinay Agarwal",
  meta: "IIT-Kanpur, IIM-Calcutta",
  roles: "Ex-CEO at Shriram, BPL-Mobile, RPG, Saint-Gobain and Dish TV",
  avatar: "/assets/vinay.jpeg",
};

export const contact = {
  eyebrow: "Start Converting 50% Of Your Exhibition Leads",
  title: "Let's turn your factory's infrastructure into orders",
  desc: "This is not for everyone, and it is not meant to be. But if you are genuinely ready to double your exports, let's talk. One honest conversation is all it takes to know whether we are right for each other.",
};

export const philosophy = {
  eyebrow: "Core Strength",
  quote: "Strategy eats sales for breakfast.",
  body: [
    "Effort in the wrong direction is the most expensive mistake a manufacturer can make. Push harder on sales without a sharp strategy and you simply drain your team, your budget and your energy, while your real strength goes to waste.",
    "So I start with strategy. Razor sharp, honest, and built around your factory and your buyers. Get the direction right, and everything after it, sales, exhibitions and branding, finally starts to add up.",
  ],
  pillars: [
    {
      n: "01",
      title: "Razor-sharp strategy",
      body: "The direction that decides whether every rupee and every hour you invest actually moves the needle. This is where I go deepest.",
    },
    {
      n: "02",
      title: "Branding as a tool",
      body: "A powerful amplifier, but only a tool. It lifts a strategy that is already sound. It can never rescue one that is not.",
    },
    {
      n: "03",
      title: "Trust that closes",
      body: "Buyers commit to businesses they believe in. We build that belief on purpose, until the deal feels obvious.",
    },
  ],
};

export const globalBrand = {
  eyebrow: "Beyond Selling More",
  title: "From a manufacturer to a global brand buyers respect",
  lead: "Selling more is only the first step. The real prize is becoming a name buyers seek out, and pay a premium for, before they even ask the price.",
  points: [
    {
      title: "A brand, not a supplier",
      body: "We shift how the world sees you, from one more vendor on a list to the maker buyers trust by name.",
    },
    {
      title: "Premium, not the cheapest",
      body: "When your capability is shown the right way, price stops being the argument. Value takes over, and margins follow.",
    },
    {
      title: "Recognised across borders",
      body: "A clear, consistent story that lands the same way in Dubai, Germany or the US, so you show up like a global player.",
    },
  ],
  closer: "This is the difference between winning one more order and building a business the next generation is proud to run.",
};

/* ============================ BRAND PAGE ============================ */

export const brandPage = {
  hero: {
    eyebrow: "Brand Strategy for Manufacturers",
    title: "Make your brand worth more.",
    sub: "You may have a world class product. But does your brand look world class too?",
    body: "I help ambitious manufacturers build a stronger global presence through strategy, positioning, branding, exhibitions, websites, 3D visuals, digital experiences and complete execution.",
    goalTitle: "The goal is simple.",
    goals: ["Stand apart.", "Look better.", "Build trust.", "Command more value."],
    ctaPrimary: "Let's talk",
    ctaSecondary: "See our work",
    image: "/assets/brand/booth.jpg",
  },
  problem: {
    eyebrow: "The Real Problem",
    title: "Your product is not the only thing buyers see.",
    body: "Before a buyer understands your product, they see your brand, booth, website, packaging, presentation, people and communication. All these things create an impression. And that impression shapes how buyers see your company.",
    statement: "We help make that impression stronger.",
    touchpoints: ["Brand", "Booth", "Website", "Packaging", "Presentation", "People", "Communication"],
  },
  value: {
    eyebrow: "Perceived Value",
    title: ["Don't just look bigger.", "Look more valuable."],
    body: "Many manufacturers compete by saying the same things. Better quality. Better technology. Better service. Better price. Everyone says it.",
    question: "Why should a buyer see your company differently?",
    close: "We help you answer that question, and express the answer consistently across the touchpoints that matter most to buyers.",
  },
  caseStudy: {
    eyebrow: "Case Study",
    title: "Param Dairy",
    subtitle: "From a dairy manufacturer to a global facing brand.",
    body: "Success in exports isn't just about products. It is about trust, authority and brand recall. Param needed a stronger presence to stand out at international exhibitions and communicate their strengths more clearly to international buyers. We brought the strategy to life across many touchpoints.",
    oneStrategy: "One strategy. Many touchpoints.",
    gallery: [
      { src: "/assets/brand/booth.jpg", label: "Booth Design", span: "wide" },
      { src: "/assets/brand/products.jpg", label: "3D Product Visuals", span: "tall" },
      { src: "/assets/brand/vpv-tab.jpg", label: "Virtual Plant Visit", span: "wide" },
      { src: "/assets/brand/authority.jpg", label: "The Book", span: "tall" },
      { src: "/assets/brand/web.jpg", label: "Website", span: "wide" },
      { src: "/assets/brand/business-card.jpg", label: "Business Card", span: "normal" },
      { src: "/assets/brand/invitation.jpg", label: "Invitation", span: "tall" },
      { src: "/assets/brand/mcb.jpg", label: "MCB & Messaging", span: "wide" },
      { src: "/assets/brand/linkedin.jpg", label: "LinkedIn Profile", span: "wide" },
      { src: "/assets/brand/expo1.jpg", label: "Exhibition", span: "normal" },
      { src: "/assets/brand/expo2.jpg", label: "Exhibition", span: "tall" },
      { src: "/assets/brand/testimonial.jpg", label: "Testimonial", span: "wide" },
    ],
    testimonial: {
      quote: "We didn't chase buyers. They came to us.",
      author: "Namita Kumar",
      role: "Whole Time Director, Param Dairy",
    },
  },
  flow: {
    eyebrow: "How The Thinking Flows",
    steps: ["Strategy", "Positioning", "Brand message", "Exhibition", "Digital presence", "Buyer confidence", "Follow-up"],
  },
  perception: {
    line1: "Your product may be ₹100.",
    line2: "Another brand may sell something similar for ₹250.",
    body: "The difference is not always the product. It can be how the brand is positioned, how confidently it communicates, how it looks, how much trust it creates, and how clearly it shows its value.",
    close: "We work on that difference.",
  },
  areas: {
    eyebrow: "Areas Of Expertise",
    title: "Everything your brand needs to be taken seriously.",
    items: [
      { n: "01", title: "Strategy", body: "Positioning, brand promise, messaging and market differentiation." },
      { n: "02", title: "Brand", body: "Identity, communication system and brand consistency." },
      { n: "03", title: "Exhibition", body: "Booth strategy and design that helps attract the right buyers." },
      { n: "04", title: "Digital", body: "Website, LinkedIn presence and digital buyer communication." },
      { n: "05", title: "Product", body: "3D visuals, product presentation, photography and sales material." },
      { n: "06", title: "Buyer Confidence", body: "VPV, testimonials, authority content and tools that help buyers understand and trust your capability." },
    ],
  },
  statement: ["We don't believe in decorating businesses.", "We believe in making businesses look as good as they actually are."],
  transformation: {
    eyebrow: "The Transformation",
    title: ["Your brand may start with a logo.", "But it ends with a perception."],
    from: ["Good factory", "Good products", "Good people", "Good technology"],
    to: ["Clear positioning", "Strong brand", "Better presentation", "Greater buyer confidence"],
    close: "A business that looks ready for the next level.",
  },
  vpvLink: {
    eyebrow: "And Then There Is The Factory",
    title: "A beautiful brand can create interest.",
    body: "But eventually the buyer wants to know. Can you actually make it? That is where VPV comes in. We help buyers see the capability behind the brand.",
    cta: "Explore VPV",
  },
  experience: {
    eyebrow: "Experience",
    title: "20+ years of helping businesses communicate their value.",
    story: "I started with design. Then came branding. Then exhibitions. Then digital. Then VPV. Over the years I realised they were all solving the same problem. Helping good businesses be seen differently.",
    name: "Nitin Gupta",
    role: "Export Marketing Strategist",
    photo: "/assets/nitin.png",
  },
  finalCta: {
    title: "Think your brand can command more value?",
    body: "Let's look at where you are today, and where you want to go.",
    cta: "Book a Brand Strategy Call",
  },
};



/* ============================ VPV PAGE ============================ */

export const vpv = {
  hero: {
    eyebrow: "VPV - Virtual Plant Visit",
    stat: "80%",
    headline: "Their export lead conversion is 80% now.",
    sub: "They are onboarding international buyers in just 3 months instead of 10, using VPV.",
    videoId: "62asCfqRRbw",
    cta: "Book an Export Strategy Call",
  },
  trust: {
    eyebrow: "The Real Bottleneck",
    title: "Winning a buyer's trust in your capabilities is the hardest sale of all",
    lead: "Buyers do not trust you easily, and in that gap of doubt, your competition quietly walks away with the business.",
    worse: [
      "Your product is seen as just another commodity, with no real difference.",
      "Your competition always seems to be one step ahead.",
      "Meeting your yearly sales targets starts to feel impossible.",
      "Buyers do not have the time to fly down and visit your plant.",
      "Despite follow up after follow up, the conversation never moves forward.",
    ],
    promiseTitle: "What if one single tool could help you...",
    promise: [
      "Build instant, unshakable trust",
      "Convert 80% more leads from every exhibition",
      "Speed up a buyer's decision by up to 70%",
      "Give you a clear edge over the competition",
    ],
  },
  imagine: {
    body:
      "Imagine a marketing tool far more convincing than your corporate video. One that shows your plant in stunning detail and builds real confidence in your buyer in the very first meeting. It lets you charge a premium, stand out as the leader in your field, and give your sales team the technical edge and quiet confidence to close bigger deals.",
  },
  intro: {
    eyebrow: "Introducing",
    title: "Virtual Plant Visit",
    subtitle: "VPV. Virtual factory tours that win buyer trust.",
    desc: "VPV, also known as a virtual factory tour, is an immersive walk through your plant that builds solid trust with your buyers. It shows your in house production, your teams, cleanrooms, labs, toolrooms, certifications and process videos, all in a single click.",
    demoVideoId: "RXvJ3LgvRBQ",
  },
  testimonials: [
    { name: "Keshav Bhatia", role: "Managing Director, GRKC", place: "Delhi, India", tag: "Food Industry", videoId: "BUlBN0rw98A", quote: "Charged a premium in exports, because of VPV." },
    { name: "Sunder Jindal", role: "Managing Director, HP Fasteners Pvt. Ltd.", place: "Faridabad", tag: "Fasteners", videoId: "qM43QYnTZmY", quote: "Cracking OEM accounts with VPV." },
    { name: "Ankeet", role: "Sales Executive, Nandan GSE Pvt Ltd.", place: "Mumbai, India", tag: "Engineering", videoId: "d1MTdiuSmAo", quote: "VPV is 10x better than a corporate video." },
    { name: "Sangharsh Kale", role: "Business Development Head, Nandan GSE", place: "Mumbai, India", tag: "Engineering", videoId: "pc3tanq9z98", quote: "A 1 crore order using VPV, and that too from a cold call." },
    { name: "Vee Tee Auto", role: "GM Operations", place: "India", tag: "Auto Components", videoId: "kJf2_vdJQ_M", quote: "Building buyer trust with a virtual factory tour." },
    { name: "Amit Jain", role: "Managing Director, Kesaria Rubber Industries Ltd.", place: "Gurgaon", tag: "Rubber", videoId: "h5oLPr-ZFyk", quote: "Closing export deals with VPV." },
    { name: "Ankur Hora", role: "Managing Director, Ecoste", place: "India", tag: "Sustainable Products", videoId: "t09Q71m6fU4", quote: "Standing out globally with a Virtual Plant Visit." },
    { name: "Mr. Mohan", role: "Managing Director, Miicron Speciality Chemicals", place: "India", tag: "Chemicals", videoId: "lJmk8VpPx0E", quote: "Turning plant capability into real export orders." },
  ],
  benefits: [
    "Instant trust building, on Zoom or at the exhibition",
    "Clear difference from your competition",
    "10x customer engagement",
    "Higher profit margins",
    "Double the efficiency of your sales team",
    "A 50% shorter sales cycle",
    "Total control over your sales process",
    "A faster path to getting shortlisted with OEMs",
    "Stronger brand value",
    "Bringing your lost customers back",
  ],
  closing: {
    title: "With every click, you move one step closer to closing the deal",
    desc: "Just send me a WhatsApp saying I want to know more, and I will personally get back to you.",
  },
};
